import clsx from 'clsx'
import React from 'react'

import {useConfig} from '../../../config'
import {getAssetUrl} from '../../../utils'
import logoEn from './assets/logo_en.svg'
import logoRu from './assets/logo_ru.svg'
import logoYango from './assets/logo_yango.svg'
import styleClasses from './classes.module.css'

type Props = {
  isMobile?: boolean
}

export function Logo({isMobile}: Props) {
  const {brand, lang} = useConfig()

  let logoInfo = {
    className: isMobile ? styleClasses.yandexSmall : styleClasses.yandex,
    img: logoRu,
  }

  if (lang !== 'ru') {
    logoInfo = {
      className: styleClasses.langEn,
      img: logoEn,
    }
  }

  if (brand === 'yango') {
    logoInfo = {
      className: styleClasses.yango,
      img: logoYango,
    }
  }

  const className = clsx(styleClasses.root, styleClasses.yandex, logoInfo.className)

  return (
    <a className={styleClasses.link} href="/">
      <img alt="logo" className={className} src={getAssetUrl(logoInfo.img)} />
    </a>
  )
}
